// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"81":"dist/css/editor","883":"dist/css/admin","921":"dist/css/main"}[chunkId] + ".css";
};